const DocumentConfig = {
  validUploadFileFormats: [
    'image/jpg',
    'image/jpeg',
    'image/gif',
    'image/png',
    'image/bmp',
    'image/tif',
    'image/psd',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.tif',
    '.tiff',
    '.psd'
  ],
  dropZoneConfigs: {
    filesLimit: 1,
    showPreviews: false,
    maxFileSize: 5000000,
    previewGridDirection: 'row'
  },
  tmfLevelConfigs: [
    {
      id: 1,
      key: 'study'
    },
    {
      id: 2,
      key: 'country'
    },
    {
      id: 3,
      key: 'site'
    }
  ]
};

export default DocumentConfig;
